@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../../../../../orders/order-details/configure-shipment/fields/fields.module.less';

.banner {
  .field-content();
}

.banner-message {
  grid-column: 1;
}
